interface PageTitleProps {
    title: string;
    subtitle?: string;
}

const PageTitle = ({ title, subtitle }: PageTitleProps) => {
    return (
        <div className="flex flex-col items-center mx-auto mb-4 w-full text-center">
            <h1 className="font-bold text-3xl sm:text-5xl tracking-tight text-balance">
                {title}
            </h1>
            <p className="text-neutral-500 text-xl mt-3">{subtitle}</p>
        </div>
    );
};

export default PageTitle;
